import {Typed} from "app/stimulus/typed-stimulus";
import {Controller} from "@hotwired/stimulus";
import {AsStimulusController} from "app/stimulus/as-stimulus-controller";

@AsStimulusController('ibc-authentication-device-instance')
export default class extends Typed(Controller<HTMLElement>)
{
    public removeSelf(): void {
        this.element.remove();
    }
}
